import { motion, useReducedMotion } from 'framer-motion';
import { useEffect } from 'react';

import NavbarSuarteworldIcon from '@/assets/all-icons/navbar-suarteworld-icon.jsx';

import './styles/SuarteworldTransition.css';

const NAVIGATION_DELAY_MS = 260;
const EXIT_FALLBACK_MS = 4200;
const ICON_IDLE_DURATION_S = 2.8;

export default function SuarteworldTransition({ active, phase, runId, onNavigate, onFallback, onExitComplete }) {
  const reducedMotion = useReducedMotion();
  useEffect(() => {
    if (!active) return undefined;

    const navigationTimer = setTimeout(() => onNavigate?.(), NAVIGATION_DELAY_MS);
    const fallbackTimer = setTimeout(() => onFallback?.(), EXIT_FALLBACK_MS);

    return () => {
      clearTimeout(navigationTimer);
      clearTimeout(fallbackTimer);
    };
  }, [active, onFallback, onNavigate, runId]);

  if (!active) return null;

  const isRevealing = phase === 'revealing';
  const duration = reducedMotion ? 0.12 : (isRevealing ? 0.42 : 0.26);
  const iconInitial = reducedMotion
    ? { opacity: 1, scale: 1, y: 0, rotate: 0 }
    : { opacity: 0, scale: 0.94, y: 6, rotate: -1.2 };
  const iconAnimate = isRevealing
    ? { opacity: 0, scale: 1.03, y: 0, rotate: 0 }
    : reducedMotion
      ? { opacity: 1, scale: 1, y: 0, rotate: 0 }
      : {
        opacity: 1,
        scale: [1, 1.018, 1],
        y: [0, -2, 0],
        rotate: [0, 1.2, 0],
      };

  return (
    <motion.div
      key={runId}
      className="suarteworld-transition"
      aria-hidden="true"
      initial={{ opacity: 0 }}
      animate={{ opacity: isRevealing ? 0 : 1 }}
      transition={{
        duration,
        ease: isRevealing ? [0.22, 0, 0.2, 1] : [0.4, 0.14, 0.3, 1],
      }}
      onAnimationComplete={(definition) => {
        if (isRevealing && definition.opacity === 0) onExitComplete?.();
      }}
    >
      <motion.div
        className="suarteworld-transition__icon"
        initial={iconInitial}
        animate={iconAnimate}
        transition={{
          duration: reducedMotion ? 0.12 : (isRevealing ? 0.22 : ICON_IDLE_DURATION_S),
          delay: reducedMotion || isRevealing ? 0 : 0.04,
          ease: isRevealing ? [0.22, 0, 0.2, 1] : [0.37, 0, 0.63, 1],
          times: isRevealing || reducedMotion ? undefined : [0, 0.5, 1],
          repeat: isRevealing || reducedMotion ? 0 : Infinity,
        }}
      >
        <NavbarSuarteworldIcon />
      </motion.div>
    </motion.div>
  );
}
